import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import ChatComposer from "./ChatComposer";
import FilePreview from "./FilePreview";

const ThreadPanel = ({ thread, onClose }) => {
  const [activeFile, setActiveFile] = useState(
    thread?.attachments?.[0] || null
  );

  return (
    <aside className="thread-panel">
      {/* Header */}
      <div className="thread-header border-bottom">
        <strong>Thread</strong>
        <FiX onClick={onClose} />
      </div>

      {/* Parent Message */}
      <div className="overflow-auto" style={{height: "calc(100vh - 165px)"}}>
        <div className="thread-parent border-bottom">
          <div className="avatar">{thread.avatar}</div>
          <div>
            <strong>{thread.user}</strong>
            <div style={{ lineHeight: 1 }}>
              <span style={{ fontSize: 12 }}>{thread.text}</span>
            </div>

            {/* Attachment list */}
            {thread.attachments?.length > 0 && (
              <div className="attachment-list mt-2">
                {thread.attachments.map((file) => (
                  <div
                    key={file.id}
                    className={`attachment-item ${
                      activeFile?.id === file.id ? "active" : ""
                    }`}
                    onClick={() => setActiveFile(file)}
                    title={file.name || file.title}
                  >
                    {file.name || file.title}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Preview Area */}
        <div className="thread-replies">
          {activeFile ? (
            <FilePreview file={activeFile} />
          ) : (
            <p className="text-muted-sm">Select a file to preview</p>
          )}
        </div>
      </div>

      <ChatComposer channelName="thread" />
    </aside>
  );
};

export default ThreadPanel;
